import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import BeneficiaryAccordion from '../../beneficiaries/components/BeneficiaryAccordion';

/**
 * Read-only monetic configuration display for Payludd beneficiaries.
 * @param {object} root0 component props
 * @param {Array<object>} root0.beneficiaries beneficiaries from terminal state
 * @returns {JSX.Element} monetic configuration section
 */
function MoneticConfigurationView({ beneficiaries }) {
    const [openItems, setOpenItems] = useState([]);

    const normalizedBeneficiaries = useMemo(() => beneficiaries.map((beneficiary, beneficiaryIndex) => {
        const contracts = (beneficiary.contracts ?? []).map((contract, contractIndex) => ({
            // ContractCard expects these exact keys
            contract: contract.merchantId || '',
            rank: contract.nlsa || '',
            bankCode: contract.bankCode || '',
            application: contract.applicationType || 'CBEMV',
            // uuid is used as key in BeneficiaryAccordion
            uuid: `${beneficiary.name || 'beneficiary'}-${contract.merchantId || 'contract'}-${contractIndex}`,
            // keep raw values if needed later
            ...contract
        }));

        return {
            uuid: beneficiary.uuid || `${beneficiary.name || 'beneficiary'}-${beneficiaryIndex}`,
            name: beneficiary.name || '',
            color: beneficiary.color || '#e5e7eb',
            contracts
        };
    }), [beneficiaries]);

    useEffect(() => {
        setOpenItems(normalizedBeneficiaries.map((_, index) => `beneficiary-${index}`));
    }, [normalizedBeneficiaries]);

    return (
        <div className='space-y-3'>
            <div className='font-semibold'>Configuration monétique</div>
            {normalizedBeneficiaries.length > 0
                ? <BeneficiaryAccordion
                    beneficiaries={normalizedBeneficiaries}
                    openItems={openItems}
                    setOpenItems={setOpenItems}
                    showActions={false}
                    displayVariant='tpe'
                />
                : <span></span>}
        </div>
    );
}

MoneticConfigurationView.propTypes = {
    beneficiaries: PropTypes.array.isRequired
};

export default MoneticConfigurationView;
